<template>
  <div class="out-room-item" @click="handleClick">
    <div class="out-room-container">
      <div
        class="out-avatar"
        :style="{ backgroundImage: `url(${avatar})` }"
      ></div>
      <div class="out-name-container out-text-ellipsis">
        <div class="out-title-container">
          <!---->
          <div class="out-room-name out-text-ellipsis">
            {{ t("message.ai.title") }}
          </div>
        </div>
        <div class="out-text-last">
          <!---->
          <div class="out-format-message-wrapper out-text-ellipsis">
            {{ t("message.ai.slogan") }}
          </div>
          <!---->
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import avatar from "@/assets/images/ai-chat/logo.png";

import { useRouterAdv } from "@/composables/use-router-adv";
import { useI18n } from "vue-i18n";

const routerAdv = useRouterAdv();
const handleClick = () => {
  routerAdv.navigateTo({ path: "/ask-shop" });
};

const { t } = useI18n();
</script>

<style>
.message-box.message-list {
  overflow-y: auto !important;
}
</style>
<style lang="scss" scoped>
.out-text-ellipsis {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.out-room-item {
  min-height: 60px;
  padding: 0 8px;

  .out-room-container {
    display: flex;
    flex: 1;
    align-items: center;
    width: 100%;

    .out-avatar {
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      height: 42px;
      width: 42px;
      min-height: 42px;
      min-width: 42px;
      margin-right: 15px;
    }
    .out-name-container {
      flex: 1;
      padding: 17px 0;
      border-bottom: 0.5px solid #f5f5f5;

      .out-title-container {
        display: flex;
        align-items: center;
        line-height: 25px;

        .out-room-name {
          flex: 1;
          color: #0a0a0a;
          font-weight: 500;
        }

        .out-text-date {
          margin-left: 5px;
          font-size: 11px;
          color: #a2aeb8;
        }
      }

      .out-text-last {
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 19px;
        color: #67717a;

        .out-room-options-container {
          display: flex;
          margin-left: auto;
          .out-room-dot {
            width: 5px;
            height: 5px;
            min-width: 5px;

            background-color: #ff5656;
            color: #fff;
            margin-left: 5px;

            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px;
            font-size: 11px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
